export default __webpack_public_path__ + "static/media/altromLogoWhite.9313f8c4.svg";